import FormWrapper from '@/components/form/form-wrapper/form-wrapper';
import { SignUpForm, SignUpFieldType } from '@/components/sign-up-form/sign-up-form';
import { useRegistration } from '@/hooks/use-registration/use-registration';
import { Flex } from 'antd';
import styles from './sign-up.module.scss';
import arrowImage from '@/assets/images/arrow.svg';

export function SignUp() {
  const { registerUser, registrationError, isRegistering } = useRegistration();

  const onFinish = async (values: SignUpFieldType) => {
    await registerUser(values);
  };

  return (
    <Flex vertical align="center">
      <FormWrapper>
        <SignUpForm
          onSubmit={onFinish}
          errors={registrationError?.response?.data?.errors}
          isLoading={isRegistering}
        />
      </FormWrapper>
      <img className={styles.arrow} src={arrowImage} />
    </Flex>
  );
}
